import { useSelector } from "react-redux";
import { Navigate  } from "react-router-dom";

const Privateroute = ({ children }) => {
  const { isAuth, loading } = useSelector((store) => store.auth);

  if (loading) {
    return <div className="h-screen w-screen flex justify-center items-center">Checking Authentication...</div>;
  }

  if (isAuth) {
    return children;
  }

  return <Navigate to="/" />;
};

export default Privateroute;
